"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "abbadia-lariana": {
    "7edb3d8e": [{
      "hkey": "a501c1e6",
      "slug": "linzanico-novegolo",
      "name": "Linzanico-Novegolo",
      "primary": true,
      "skipSearch": false
    }],
    "linzanico": [{
      "hkey": "a501c1e6",
      "slug": "linzanico-novegolo",
      "name": "Linzanico-Novegolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f369befe": [{
      "hkey": "a1e2d479",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bordino": [{
      "hkey": "a1e2d479",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "abbadia-lariana"
    }],
    "2ec28b3c": [{
      "hkey": "a1e2d479",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "novegolo": [{
      "hkey": "a1e2d479",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "abbadia-lariana"
    }],
    "9a6cbe9a": [{
      "hkey": "39db428b",
      "slug": "abbadia-lariana",
      "name": "Abbadia Lariana",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-carlo-porta": [{
      "hkey": "39db428b",
      "slug": "abbadia-lariana",
      "name": "Abbadia Lariana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;